import { TourService } from '../services/tour/tour.service';

export const tourNextButton = (buttonText?: string) => {
  return {
    classes: 'tour-btn tour-primary-btn',
    text: buttonText ?? 'Next',
    label: buttonText ?? 'Next',
    type: 'next', //note: if action is provided, 'type' behavior is overridden for all button types
  };
};

export const tourBackButton = (buttonText?: string, extraClasses?: string[]) => {
  return {
    classes: 'tour-btn tour-secondary-btn ' + (extraClasses?.join(',') ?? ''),
    secondary: true,
    text: 'Back',
    label: buttonText ?? 'Back',
    type: 'back',
  };
};

export const tourExitButton = (service: TourService, buttonText?: string) => {
  return {
    classes: 'tour-btn tour-warn-btn',
    secondary: true,
    text: buttonText ?? 'Exit Tour',
    label: buttonText ?? 'Exit Tour',
    action: () => service.skip(), // no type specified as custom behavior always needed
  };
};

export const tourCustomButton = (
  buttonText: string,
  color: 'primary' | 'secondary' | 'warn',
  action: () => void,
  extraClasses?: string[]
) => {
  return {
    classes: `tour-btn tour-${color}-btn ` + (extraClasses?.join(' ') ?? ''),
    secondary: color !== 'primary',
    text: buttonText,
    label: buttonText,
    action: action,
  };
};
